// App.js
import React, { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppProvider } from "./AppContext.js";
import { LearnerProvider, LearnerBar } from "./LearnerContext.js";
import Header from "./components/Header.js";
import Footer from "./components/Footer.js";
import AppRoutes from "./routes/AppRoutes.js";
import { Toaster } from "react-hot-toast";
import { loadMathJax, needsMathJax } from "./mathjax.js";

// Trang bảng thù lao của giáo viên (/ten-giao-vien/thang-10-2026) là trang riêng: không menu, không chân trang
const BARE_PAGE = /^\/[^/]+\/thang-\d{1,2}(-\d{4})?\/?$/;
// Trang quản trị có thanh tiêu đề riêng (AdminHeader), không dùng menu và chân trang của trang học
const ADMIN_PAGE = /^\/admin\/?$/;

const Shell = () => {
  const { pathname } = useLocation();
  const isBare = BARE_PAGE.test(pathname) || ADMIN_PAGE.test(pathname);
  // Chỉ tải MathJax khi vào trang có công thức
  useEffect(() => {
    if (needsMathJax(pathname)) loadMathJax();
  }, [pathname]);
  return (
    <>
      {!isBare && <Header />}
      {!isBare && <LearnerBar />}
      <Toaster position="top-right" reverseOrder={false} />
      <main className="flex-grow animate-fade-in-content">
        <AppRoutes />
      </main>
      {!isBare && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <AppProvider>
      <LearnerProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col font-inter bg-gray-100 antialiased">
          {/* Tailwind CSS CDN */}
          <script src="https://cdn.tailwindcss.com"></script>
          {/* Petrona font */}
          <link
            href="https://fonts.googleapis.com/css2?family=Petrona:wght@400;700&display=swap"
            rel="stylesheet"
          />
          <style>
            {`
              body {
                font-family: 'Petrona', serif;
                font-size: 1.1rem;
              }
              .font-petrona {
                font-family: 'Petrona', serif;
              }
              .MathJax, .MJXc-display {
                  background: transparent !important;
              }

              .MathJax_Display {
                  background: transparent !important;
                  overflow-x: auto;
                  overflow-y: hidden;
              }
              .animate-fade-in-content {
                animation: fadeInContent 1s ease-out forwards;
              }
              @keyframes fadeInContent {
                from { opacity: 0; }
                to { opacity: 1; }
              }
            `}
          </style>

          <Shell />
        </div>
      </BrowserRouter>
      </LearnerProvider>
    </AppProvider>
  );
};

export default App;
